import { checkEnvironment } from '@saviynt/common';

/** Wildcard URL for MFA backend to match against protected URI list */
export const downloadRdpFileProtectedUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/rdp-api-handler/sessions/*/rdp`;
};

const downloadRdpFileUrl = (sessionId) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/rdp-api-handler/sessions/${sessionId}/rdp`;
};

export default downloadRdpFileUrl;
